<template>
  <div class="index-text-section">
    <text-content-wrapper>
      <template v-slot:col-1>
        <div class="heading-2" v-html="fields.field_one.value.text"></div>
        <div class="line-separator"></div>
        <div class="heading-3-bold" v-html="fields.field_two.value.text"></div>
        <div class="line-separator"></div>
      </template>
      <template v-slot:col-2>
        <div class="lead-1" v-html="fields.field_three.value.text"></div>
        <div class="paragraph-1" v-html="fields.field_four.value.text"></div>
        <div class="paragraph-1" v-html="fields.field_four.value.text2"></div>
        <seu-button
          :label="fields.field_four.value.buttonLabel"
          :button-link="fields.field_four.value.buttonLink"
          :button-icon-before="buttonIcon"
        />
      </template>
    </text-content-wrapper>
  </div>
</template>

<script>

import TextContentWrapper from "/seu-frontend/sections/general/TextContentWrapper";
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: 'IndexTextSection',
  components: {SeuButton, TextContentWrapper},
  props: {
    fields: {
      type: Object
    }
  },

  data() {
    return {
      buttonIcon: require('../../assets/static-icons/arrow-right.svg')
    }
  }
}
</script>

<style lang="scss">
@import "IndexTextSection.scss";
</style>
